//--- Used on mobile only, add an overlay on top of the map
const OverlayHeader = ({
  title,
  setMapScreen,
  setFilterScreen,
  setSelectedInstitution,
  filtersKeys,
  filtersState,
  setShowFiltersFrom,
}) => {
  const closeMapScreen = () => {
    document.body.classList.remove("no-scroll");
    setMapScreen(false);
    setSelectedInstitution("");
  };

  const openFilterScreen = () => {
    document.body.classList.add("no-scroll");
    setFilterScreen(true);
    setMapScreen(false);
    setShowFiltersFrom("from-map");
  };

  //count active filters
  let activeFilterCount = 0;
  filtersKeys.forEach((key) => {
    if (filtersState[key]?.length) {
      activeFilterCount += filtersState[key]?.length;
    }
  });

  return (
    <div className="map__wrapper--title">
      <h3 className="sidebar__title">{title}</h3>
      <div>
        <button
          className="map__wrapper--button"
          onClick={() => openFilterScreen()}
        >
          <span className="icon iconReactLeafletfilter-map"></span>
          {activeFilterCount !== 0 && (
            <span className="count">{activeFilterCount}</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default OverlayHeader;
